import { faTag } from '@elynx/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, IconButton, Link, Theme } from "@mui/material";
import { CropSquare, ExpandMore, FilterNone, FilterNoneTwoTone } from "@mui/icons-material";
import React from "react";
import { INavigationItem } from "../../services/navigation-data-service/Models";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";


export type BreadCrumbItemProps = {
    item: INavigationItem;
    showAnchor: boolean;
    onClick: (item: INavigationItem, shiftKey: boolean, ctrlKey: boolean) => void;
    onAnchorClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export default function BreadCrumbItem({item, showAnchor, onClick, onAnchorClick}: BreadCrumbItemProps) {

    const onItemClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, item: INavigationItem): void => {
        onClick(item, event.shiftKey, event.ctrlKey);
    }

    return (

        <Link
            sx={{
                color: "text.secondary",
                textDecoration: item.isHidden ? 'line-through' : undefined,
                fontStyle: item.isObjectDisabled || !item.allowClick ? 'italic' : undefined,
                display: "flex",
                "&:hover": {
                    textDecoration: item.isHidden ? 'line-through' : undefined,
                    cursor: "pointer"
                },
                "& svg": {
                    marginTop: 'auto',
                    marginBottom: 'auto',
                    marginRight: 0.5,
                    width: (theme: Theme) => theme.spacing(2),
                    height: (theme: Theme) => theme.spacing(2),
                }
            }}
            onClick={(e:React.MouseEvent<HTMLAnchorElement, MouseEvent>) => onItemClick(e, item)}
        >

            {
                item.objectTypeID === eLynxObjectTypeEnum.Tag
                    ? <FontAwesomeIcon icon={faTag} size='sm'/>
                    : item.objectTypeID === eLynxObjectTypeEnum.Group
                        ? item.isPeerGroup
                            ? <FilterNoneTwoTone/>
                            : <FilterNone/>
                        : <CropSquare/>
            }

            <Box sx={{
                marginTop: 'auto',
                marginBottom: 'auto',
                color: "text.primary"
            }}>
                {item.title}
            </Box>            

            {showAnchor && <
                IconButton id='relatedItems' sx={{
                    padding: 0.25
                }}
                    aria-label="related"
                    aria-controls="related-items-menu"
                    aria-haspopup="true"
                    //User Story 53044: Research - 2025 Q2 - Review GAS report
                    onClick={onAnchorClick}>
                    <ExpandMore />
                </IconButton>
            }
        </Link>
    );
  }
